(ns com.theplantscape.plant-web.components.tailwind.forms.user
  (:require
   [com.theplantscape.plant-web.components.forms.core
    :refer [update-atom-hm]]

   [com.theplantscape.plant-web.components.tailwind.buttons
    :refer [button-progress-async]]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [form]]
   [com.theplantscape.web-ui.tailwind.form.elements.input :as f]
   [reagent.core :as r]))

(defn ui-form-user [values cfg]
  (let [style "p-2 w-full "
        set-form-value (partial update-atom-hm values)]
    (fn [values cfg]
      [:div.w-full
       (str @values)
       [form [:<>
              [:div.grow
               [f/ui-form-input
                (r/cursor values [:values :user/display-name])
                {:name "user/display-name"
                 :tooltip "Display name"
                 :input-classes (str style " w-full grow")
                 :store-fn set-form-value}]]

              [f/ui-form-input
                (r/cursor values [:values :user/profile-image])
                {:name "user/profile-image"
                 :tooltip "Profile image"
                 :input-classes (str style " w-full grow")
                 :store-fn set-form-value}]

              #_[:div.grow
                   [form/ui-input-fn
                    "Description"
                    "user|description"
                    {:input-classes (str style " w-full grow")
                     :on-change-fn set-form-value}]]

              [:div.mt-4
               [button-progress-async
                "Update"
                {:on-click #((:on-submit cfg) (:values @values))
                 :on-complete (:on-submit-complete cfg)}]]]]])))
